import { Link as RouterLink } from 'react-router-dom';
import { Link, List, ListItem, Text, VStack } from '@chakra-ui/react';
import {
  RULES_DURING_TOURNAMENT_ANCHOR,
  RULES_MODAL_TOURNAMENT_SUMMARY,
} from '@/constants/tournamentRulesCopy';

export function RulesModalTournamentSummary() {
  return (
    <VStack align='stretch' spacing={2} pb={2}>
      <Text fontSize='sm' fontWeight='semibold'>
        During the tournament
      </Text>
      <List spacing={1} styleType='disc' pl={4} fontSize='sm' color='gray.500'>
        {RULES_MODAL_TOURNAMENT_SUMMARY.map((line) => (
          <ListItem key={line}>{line}</ListItem>
        ))}
      </List>
      <Link
        as={RouterLink}
        to={`/rules#${RULES_DURING_TOURNAMENT_ANCHOR}`}
        fontSize='sm'
        color='green.500'
        fontWeight='medium'
      >
        Read full tournament rules
      </Link>
    </VStack>
  );
}
